export function getRem(value: number): string {
  return `calc((${value} / var(--dnv-font-base-unitless)) * 1rem)`;
}

export function getFontWeight(weight: 'normal' | 'semibold' | 'bold'): string {
  const weights = {
    normal: '400',
    semibold: '600',
    bold: '700',
  };

  return weights[weight];
}
